import {LANGUAGE_SET_SUCCESS} from "./types";

export const defaultHeaders = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
import RSAA from "redux-api-middleware/es/RSAA";
import * as types from './types';

export const loadDashboard = (namespace, as_employee) => {

    let body = {};
    if (as_employee) body['as_employee'] = as_employee ;

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/dashboard`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.DASHBOARD_LOAD,
                types.DASHBOARD_LOAD_SUCCESS,
                types.DASHBOARD_LOAD_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(body)
        },
        auth: true
    };

};

export const loadConstants = () => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/api/v1/candidate_accounts/constants`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.CONSTANTS_LOAD,
                types.CONSTANTS_LOAD_SUCCESS,
                types.CONSTANTS_LOAD_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const loadImportantDocuments = (namespace) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/important_documents`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.IMPORTANT_DOCUMENTS_LOAD,
                types.IMPORTANT_DOCUMENTS_LOAD_SUCCESS,
                types.IMPORTANT_DOCUMENTS_LOAD_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const selectAssignment = (namespace, id) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/candidate_accounts/assignments/${id}`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.ASSIGNMENT_SELECT,
                types.ASSIGNMENT_SELECT_SUCCESS,
                types.ASSIGNMENT_SELECT_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const loadLifeAtInnogy = (namespace) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/life_at_innogy`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.LIFE_AT_INNOGY_LOAD,
                types.LIFE_AT_INNOGY_LOAD_SUCCESS,
                types.LIFE_AT_INNOGY_LOAD_ERROR
            ],
            credentials: 'same-origin'
        },
        auth: true
    };

};

export const assignmentEmployeeAction = (namespace, id, action) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/candidate_accounts/assignments/${id}/employee_action`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.ASSIGNMENT_ACTION,
                types.ASSIGNMENT_ACTION_SUCCESS,
                types.ASSIGNMENT_ACTION_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(action)
        },
        auth: true
    };

};


export const assignmentEmployeeActionUpload = (values, id, action, data) => {
    let namespace = 'api/v1';

    const formData = new FormData();
    formData.append('execute', action);

    for ( const key in data ) {
        formData.append(`data[${key}]`, data[key]);
    }

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/${namespace}/candidate_accounts/assignments/${id}/employee_action`,
            method: 'POST',
            types: [
                types.ASSIGNMENT_ACTION,
                types.ASSIGNMENT_ACTION_SUCCESS,
                types.ASSIGNMENT_ACTION_ERROR
            ],
            credentials: 'same-origin',
            body: formData
        },
        auth: true
    }

};

export const activateUser = (data) => {

    return {
        [RSAA]: {
            endpoint: `${process.env.API_HOST}/auth/confirm`,
            method: 'POST',
            headers: defaultHeaders,
            types: [
                types.ACCOUNT_ACTIVATION,
                types.ACCOUNT_ACTIVATION_SUCCESS,
                types.ACCOUNT_ACTIVATION_ERROR
            ],
            credentials: 'same-origin',
            body: JSON.stringify(data)
        },
        auth: true
    };

};

export const setLang = (locale) => {
    return {
        type: types.LANGUAGE_SET_SUCCESS,
        payload: {
            locale: locale
        }
    }
};
